import { View } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { MessageBanner, MessageBannerType } from "@amzn/stencil-react-components/message-banner";
import React, { FC } from "react";
import { OPS_TECH_LINK_LABEL, OPS_TECH_MESSAGE, OPS_TECH_URL } from "@/common/constants/ops-tech.constants";

export const OpsTechMessage: FC = () => (
  <View padding="2rem" data-testid="ops-tech-message">
    <MessageBanner type={MessageBannerType.Informational} isDismissible={false}>
      {OPS_TECH_MESSAGE} <Link href={OPS_TECH_URL}>{OPS_TECH_LINK_LABEL}</Link>
    </MessageBanner>
  </View>
);
